import { Link } from 'react-router-dom';
import { BrandMark } from './BrandMark';

const cols = [
  {
    heading: 'Product',
    links: [
      { label: 'Mela ID', to: '/' },
      { label: 'Booth Pilot', to: '/#exhibitors' },
      { label: 'Stall Recall', to: '/#exhibitors' },
      { label: 'Mela Discover', to: '/#discover' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Compare', to: '/compare' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Careers', to: '/about#careers' },
      { label: 'Press', to: '/about#press' },
      { label: 'Contact', to: '/about#contact' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy', to: '/about#privacy' },
      { label: 'Terms', to: '/about#terms' },
      { label: 'DPDP', to: '/about#dpdp' },
      { label: 'Security', to: '/about#security' },
      { label: 'Status', to: '/about#status' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="bg-ink-900 text-white pt-20 pb-10">
      <div className="container-mela">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-12 mb-16">
          <div className="col-span-2">
            <Link
              to="/"
              className="flex items-center gap-2.5 font-display font-extrabold text-[22px] -tracking-[0.03em] text-white mb-4"
            >
              <BrandMark inverted />
              <span>mela</span>
            </Link>
            <p className="text-ink-400 text-[14px] max-w-[36ch] leading-[1.6]">
              Identity infrastructure for Indian B2B. Built in India. Servers in Mumbai.
              DPDP-compliant from Day 1.
            </p>
          </div>

          {cols.map((col) => (
            <div key={col.heading}>
              <h4 className="text-[12px] font-semibold text-white mb-4 uppercase tracking-wider font-mono">
                {col.heading}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-ink-400 text-[14px] hover:text-white transition-colors duration-fast"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-ink-800 flex justify-between items-center font-mono text-[12px] text-ink-500 flex-wrap gap-4">
          <div>© {new Date().getFullYear()} Mela · melaos.co · Made in India 🇮🇳</div>
          <div className="flex gap-2.5 flex-wrap">
            <FooterBadge>DPDP-compliant</FooterBadge>
            <FooterBadge>SOC 2 (in progress)</FooterBadge>
            <FooterBadge>India Stack-native</FooterBadge>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterBadge({ children }: { children: React.ReactNode }) {
  return (
    <span className="px-2.5 py-1 bg-ink-800 border border-ink-700 rounded-md text-[11px] tracking-wide">
      {children}
    </span>
  );
}
